export const API_URL: string = process.env.REACT_APP_API_URL || "https://backend.t4ever.com/api/"
export const CHAT_API_URL: string = process.env.REACT_APP_CHAT_API_URL || "http://localhost:3002/api"
